import React from 'react'

const Panel = ({ disbursment, fees, percentageNetSalary, validation, monthlyInstallment }) => {

    return (
        <div className="row px-2">


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px', marginBottom: '5px', borderBottom: '1px solid #f2f2f2' }}>
                <span style={{ fontWeight: '400', fontSize: '14px' }}>
                    Net loan disbursment amount
                </span>

                <span style={{ fontSize: '24px', fontWeight: '400', color: '#17406b' }}>$ {disbursment}</span>
            </div>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px', marginBottom: '5px' }}>
                <span style={{ fontWeight: '400', fontSize: '14px' }}>
                    Monthly installment 
                </span>

                <span style={{ fontWeight: '400', fontSize: '14px' }}>$ {monthlyInstallment} </span>

            </div>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px', marginBottom: '5px', borderBottom: '1px solid #f2f2f2' }}>
                <span style={{ fontWeight: '400', fontSize: '14px' }}>
                    Upfront fees
                </span>

                <span style={{ fontSize: '14px', fontWeight: '400' }}>$ {fees} </span>
            </div>


            {
                validation === false ?

                    <>
                    </>
                    
                    :

                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', paddingBottom: '10px', marginBottom: '5px' }}>
                        <span style={{ fontWeight: '400', fontSize: '14px', color: '#F70000' }}>
                        Loan amount is above acceptable threshold!
                        </span>
                    </div>
            }




        </div>

    )
}

export default Panel